export default __webpack_public_path__ + "static/media/Q5_3.315dd9bd.png";